import type { SVGProps } from 'react';
const SvgFileDownloadDone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#file_download_done_svg__a)">
      <path
        fill="currentColor"
        d="M5 18h14v2H5v-2Zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3Z"
      />
    </g>
    <defs>
      <clipPath id="file_download_done_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFileDownloadDone;
